import { I18NextService } from 'angular-i18next';
export async function getLocalizationFromAsyncPipe(i18nextService: I18NextService, key: string) {
    return new Promise<string>((resolve) => {
        resolve(i18nextService.t(key) as string)
    });
}
